import React from 'react';
import { CrownFilled, DeleteOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import { upgradeModal } from 'components/common/CheckPermissions/UpgradeSubscriptionModal';

const DeleteBtnFallback = () => {
  const onClickButton = () => {
    upgradeModal.open();
  };
  return (
    <div className="delete-action-wrapper">
      <Button
        onClick={onClickButton}
        type="primary"
        shape="circle"
        icon={<DeleteOutlined />}
      />
      <CrownFilled className="action-feature-icon" />
    </div>
  );
};

export default DeleteBtnFallback;
